// Source + survey-id filters map to the BFF SurveyDefinitionFilterInput server-side fields
// (sourcePartner, partnerSurveyId). Survey-name search is handled client-side in the page,
// because the filter input has no name field.
//
// Lane choice matters: the shared harness debounces the `withDebounce` lane (one refetch per
// pause) and fires the `withoutDebounce` lane immediately. Survey ID is free text, so it lives
// in withDebounce to avoid a server refetch per keystroke; Source is a discrete select, so it
// stays in withoutDebounce.
//
// `providers` is the { id, name }[] array returned by useSurveyProviders — the same list the
// drawer uses, so the filter options always reflect the program's actual partner configuration.
export const buildSurveyFilterConfig = (providers = []) => ({
  withDebounce: {
    jsonSchema: {
      title: "Survey List Filter",
      type: "object",
      properties: {
        partnerSurveyId: {
          type: "string",
          label: "Survey ID",
        },
      },
    },
    uiSchema: {
      type: "HorizontalLayout",
      elements: [
        {
          type: "Control",
          scope: "#/properties/partnerSurveyId",
          component: "textField",
          placeholder: "Survey ID",
        },
      ],
    },
  },
  withoutDebounce: {
    jsonSchema: {
      title: "Survey List Filter",
      type: "object",
      properties: {
        sourcePartner: {
          type: "string",
          label: "Source",
          enum: providers.map((p) => p.id),
        },
      },
    },
    uiSchema: {
      type: "HorizontalLayout",
      elements: [
        {
          type: "Control",
          scope: "#/properties/sourcePartner",
          component: "stringSelect",
          placeholder: "Source",
          selection: "single",
          options: {
            labelMapping: Object.fromEntries(providers.map((p) => [p.id, p.name])),
          },
        },
      ],
    },
  },
});
